const NAME = "ASSETS_DISCOUNTS_CREATION";

export default NAME;
